export const ATTACHMENTS_INTERACTION_INIT = "ATTACHMENTS_INTERACTION_INIT";
export const HANDLE_ACTIVE_ATTACHMENT = "HANDLE_ACTIVE_ATTACHMENT";

export const HANDLE_OPEN_TAB = "HANDLE_OPEN_TAB";

export const GET_ATTACHMENTS_LIST = "GET_ATTACHMENTS_LIST";
export const GET_ATTACHMENTS_LIST_SUCCESS = "GET_ATTACHMENTS_LIST_SUCCESS";
export const GET_ATTACHMENTS_LIST_FAILURE = "GET_ATTACHMENTS_LIST_FAILURE";

export const RESET_ATTACHMENTS_INTERACTION = "RESET_ATTACHMENTS_INTERACTION";

export const UPDATE_ATTACHMENT_STATUS = "UPDATE_ATTACHMENT_STATUS";
export const UPDATE_ATTACHMENT_STATUS_SUCCESS =
  "UPDATE_ATTACHMENT_STATUS_SUCCESS";
export const UPDATE_ATTACHMENT_STATUS_FAILURE =
  "UPDATE_ATTACHMENT_STATUS_FAILURE";

export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
export const UPLOAD_ATTACHMENTS_SUCCESS = "UPLOAD_ATTACHMENTS_SUCCESS";
export const UPLOAD_ATTACHMENTS_FAILURE = "UPLOAD_ATTACHMENTS_FAILURE";

export const RESET_MESSAGE_TOASTE = "RESET_MESSAGE_TOASTE";

export const REQUEST_ATTACHMENT = "REQUEST_ATTACHMENT";
export const REQUEST_ATTACHMENT_SUCCESS = "REQUEST_ATTACHMENT_SUCCESS";
export const REQUEST_ATTACHMENT_FAILURE = "REQUEST_ATTACHMENT_FAILURE";

export const DOWNLOAD_ATTACHMENT_START= "DOWNLOAD_ATTACHMENT_START";
export const DOWNLOAD_ATTACHMENT_END = "DOWNLOAD_ATTACHMENT_END";
